import { Button, Grid } from '@mui/material';
import { Box, Container } from '@mui/system';
import React from 'react';
import { useTranslate } from 'react-admin';

type IProps = {
  onSave: () => void;
};

function ProductFunctionsBar({ onSave }: IProps) {
  const t = useTranslate();
  return (
    <Container
      sx={{
        justifyContent: 'space-between',
        display: 'flex',
      }}
    >
      <Box></Box>
      <Box>
        <Button onClick={onSave}>{t('save')}</Button>
      </Box>
    </Container>
  );
}

export default ProductFunctionsBar;
